import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { map, catchError, switchMap, withLatestFrom, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { getErrorType } from 'src/app/shared/utils/error.utils';
import {
  AdminApiKeyPageLoadedAction,
  AdminApiKeyPageRequestedAction,
  AdminApiKeysLoadedAction,
  AdminApiKeySortChangedAction,
  AdminApiKeyRevokeRequestedAction,
  AdminApiKeyRevokeRequestedSuccessAction,
} from './admin-api-key.actions';
import { AdminApiKeyService } from './../admin-api-key.service';
import { ApiKeyApiError, ApiKeyApiErrorTypes } from './../api-key.errors';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store.model';
import { getApiKeysSort } from './../api-key.selectors';
import { ApiKeyRevokeRequestedFailedAction, ApiKeysErroredAction } from '../api-key.actions';

@Injectable()
export class AdminApiKeyEffects {
  loadAdminApiKeys$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        AdminApiKeyPageLoadedAction,
        AdminApiKeyPageRequestedAction,
        AdminApiKeySortChangedAction,
        AdminApiKeyRevokeRequestedSuccessAction,
      ),
      withLatestFrom(this.store.select(getApiKeysSort)),
      switchMap(([, sort]) =>
        this.apiKeyService.loadApiKeys(sort).pipe(
          map((apiKeys) => AdminApiKeysLoadedAction({ apiKeys })),
          catchError((err) =>
            of(
              ApiKeysErroredAction({
                error: new ApiKeyApiError(getErrorType(ApiKeyApiErrorTypes, err.status), err),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  revokeAdminApiKey$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminApiKeyRevokeRequestedAction),
      mergeMap(({ apiKeyId }) =>
        this.apiKeyService.revokeApiKey(apiKeyId).pipe(
          map(() => AdminApiKeyRevokeRequestedSuccessAction()),
          catchError((err) =>
            of(
              ApiKeyRevokeRequestedFailedAction({
                error: new ApiKeyApiError(getErrorType(ApiKeyApiErrorTypes, err.status), err),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private apiKeyService: AdminApiKeyService,
    private store: Store<AppStore>,
  ) {}
}
